( function( $ ) {
	$( window ).on( 'load', function() {
		handleCustomSkeleton();

		setTimeout( function() {
			toggleAttributeSections();
		}, 3000 );


		if ( $( '.block-editor-iframe__body' ).length ) {
			setTimeout( function() {
				preparePagination();
			}, 5000 );
		}
	} );

	const categoryFilters = () => {
		$( 'input.hmt-category-filter' ).on( 'change', function( e ) {
			e.preventDefault();
			let currentUrl = new URL( window.location.href );
			let categories = '';

			$( 'input.hmt-category-filter:checked' ).each( function() {
				let separator = ',';

				if ( !categories ) {
					separator = '';
				}

				categories = categories + separator + $( this ).val();
			} );

			currentUrl.searchParams.set( 'product_cat', categories );
			window.location.href = currentUrl.href.replace(
				/(?:query-(?:\d+-)?page=(\d+))|(?:page\/(\d+)|#)/g,
				''
			);
		} );
	};

	const toggleAttributeSections = () => {
		$( '.wp-block-woocommerce-filter-wrapper .wp-block-heading' ).on( 'click', function() {
			let $filterContainer = $( this ).closest( '.wp-block-woocommerce-filter-wrapper' );
			let alreadyToggled = false;

			$filterContainer.find( '.wp-block-woocommerce-attribute-filter-custom, .wp-block-woocommerce-price-filter, .wp-block-woocommerce-attribute-filter' ).each( function() {
				if ( !$( this ).css( 'max-height' ) || $( this ).css( 'max-height' ) === 'none' ) {
					$( this ).css( 'max-height', $( this ).height() + 5 );

					setTimeout( function() {
						$filterContainer.toggleClass( 'wp-block-woocommerce-filter-wrapper--closed' );
					}, 50 );

					alreadyToggled = true;
				}
			} );

			if ( !alreadyToggled ) {
				$filterContainer.toggleClass( 'wp-block-woocommerce-filter-wrapper--closed' );
			}
		} );
	};

	const preparePagination = () => {
		let $pagination = $( '.wp-block-query-pagination' );

		if ( !$pagination.length ) {
			return;
		}

		let currentPage = $pagination.find( '.current' ).text();
		let totalPages = $pagination.find( '.page-numbers:last-child' ).text();
		let nextLink = $pagination.find( '.wp-block-query-pagination-next' ).attr( 'href' );
		let prevLink = $pagination.find( '.wp-block-query-pagination-previous' ).attr( 'href' );

		let nextLinkDisabled = '';
		let prevLinkDisabled = ';';

		if ( !nextLink ) {
			nextLink = '#';
			nextLinkDisabled = 'disabled';
		}

		if ( !prevLink ) {
			prevLink = '#';
			prevLinkDisabled = 'disabled';
		}

		const paginationHtml = `
            <div class="hmt-pagination">
                <a href="${prevLink}" ${prevLinkDisabled} class="arrow-button arrow-button--previous">
                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M26.9173 17H7.08398" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M17.0006 26.9168L7.08398 17.0002L17.0006 7.0835" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </a>

                <div class="hmt-pagination__numbers"><span class="hmt-pagination__current">${currentPage}</span> / <span class="hmt-pagination__total">${totalPages}</span></div>
                
                <a href="${nextLink}" ${nextLinkDisabled} class="arrow-button arrow-button--next">
                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M26.9173 17H7.08398" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M17.0006 26.9168L7.08398 17.0002L17.0006 7.0835" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </a>                        
            </div>
        `;


		$pagination.html( paginationHtml );
		$pagination.show();

		$( '.hmt-pagination .arrow-button' ).on( 'click', function( e ) {
			if ( $( this ).attr( 'href' ) === '#' ) {
				e.preventDefault();
			}
		} );
	};

	const showFixedFilters = () => {
		let visibleFiltersClass = 'hmt-show-shop-filters';
		var $container = $( '.section-catalog-wrapper .acf-innerblocks-container .wp-block-column:first-child' );
		let $closeButton = $container.find( 'h2:first-child' );
		let $filtersButton = $( '.woocommerce-filters-button' );
		let $body = $( 'body' );
		let $window = $( window );

		$window.on( 'resize', function() {
			$container.addClass( 'wp-block-column--disabled' );

			if ( $window.width() > 1280 ) {
				$body.removeClass( 'no-scroll' );
			} else {
				if ( $( '.' + visibleFiltersClass ).length ) {
					$body.addClass( 'no-scroll' );
				}
			}
		} );

		$filtersButton.on( 'click', function( e ) {
			e.preventDefault();

			$body.toggleClass( visibleFiltersClass ).toggleClass( 'no-scroll' );

			$( '.' + visibleFiltersClass + ' .section-catalog-wrapper' ).on( 'mouseup', function( e ) {
				if ( !$container.is( e.target ) && e.target && $filtersButton.has( e.target ).length === 0 && $container.has( e.target ).length === 0 ) {
					$closeButton.click();
					$( this ).off( 'mouseup' );
					return;
				}
			} );

			$( '.wp-block-column--disabled' ).removeClass( 'wp-block-column--disabled' );
		} );

		$closeButton.on( 'click', function( e ) {
			e.preventDefault();
			$body.removeClass( visibleFiltersClass ).removeClass( 'no-scroll' );
		} );
	};

	const handleCustomSkeleton = () => {
		let $skeletonElements = $( '.hmt-skeleton-element' );
		$skeletonElements.show();

		setTimeout( function() {
			$skeletonElements.removeClass( 'hmt-skeleton-element' );
		}, 2000 );
	};

	showFixedFilters();
	categoryFilters();
	preparePagination();
} )( jQuery );